import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { SVGHeader, SVGSourceHeader } from '../../../Svg/Header';
import { getScreenName, getUserIsLoggedIn } from '../../../Utils/helper';
import {
  navigateToCartPage,
  navigateToLoginPage,
  navigateToOrderlistPage,
} from '../../../Utils/redirections';
import { RelativeDiv } from '../../GrowthTrackerPage/Inthisweek/styled';
import {
  CartandProfileSec,
  CartIcon,
  CartImg,
  CartImgMobile,
  MobileSearch,
  ProfileImgMobile,
  ProfileImgMobileOuter,
  TrackDesktopNew,
} from '../../HomePage/NewHeader/MainHeader/styled';
import Search from '../../HomePage/NewHeader/Search';
import LoginDesktop from '../../LoginModule/LoginDesktop';
import LoginPopupContainer from '../../LoginModule/LoginPopupContainer';
import { getSearchParams } from '../../Parenting/common';
import SideDrawer from '../../Product/SideDrawer';
import { clickedSearchTabEvent } from '../../Search/instrumentation';
import { DesktopShow } from '../../StoreCategoryPage/ClothDiaperCertificates/styled';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import OnHoverStoreHeader from './OnHoverStoreHeader';
import { BrandContainer, HomeHeader, ShopButton } from './styled';

import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { useIsDesktop } from '../../../Utils/productPageUtils';
import NewHeaderArticle from '../../HomePage/NewHeader/NewHeaderArticle';
import { trendingSearchDataConstant } from '../../HomePage/NewHeader/constant';
import { setWebUserIdReact } from '../../../Utils/commonUtils';
import dynamic from 'next/dynamic';
import { isDesktopUser } from '../../../Utils/ProductUtils';
import { getWebUserType } from '../../../Utils/getWebUserType';
import { getLoginCartItems } from '../../../Utils/getLoginCartItems';
import { fireEvent } from '../../../Utils/fireEvent';

const StoreHeaderNew = (props) => {
  const {
    categoryData,
    orderSuccessHeader,
    hideMobileSearch,
    showCart,
    addedToCart,
    showHeader,
    location,
    showShopCta,
    showNewHeader,
    babyCareProduct,
    stage,
    userType,
    store,
    nostrip,
    productId,
    isForNewCdPage,
    isForJoyfulPage,
    showSsoTooltipDot,
    loginPopUp,
    setLoginPopUp,
  } = props;
  const [showSearchSectionClass, setShowSearchSectionClass] = useState(false);
  const [headerData, setHeaderData] = useState(
    JSON.parse(JSON.stringify(categoryData || [])),
  );
  const [cardEffect, setCardEffect] = useState();
  const isDesktop = useIsDesktop();
  const [showInput, setShowInput] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [cartAnimation, setCartAnimation] = useState(false);
  const [trendingSearchData, setTrendingSearchData] = useState(null);
  const router = useRouter();
  const sideDrawerHidden = useRef(false);
  const [homeUrl, setUrl] = useState('/');
  let params = null;
  if (typeof window != 'undefined') {
    params = new URLSearchParams(window.location.search);
  }
  const overlayHandler = () => {
    setShowSearchSectionClass(false);
    const params = new URLSearchParams(window.location.search);
    params.delete('search');
    if (window?.history?.length > 2) {
      router.back();
    } else {
      router.replace(
        window.location.pathname.toString() + '?' + params,
        undefined,
        { scroll: false },
      );
    }
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
  };
  const searchStateHandler = () => {
    setShowSearchSectionClass(!showSearchSectionClass);
    setShowInput(true);
    const params = new URLSearchParams(window.location.search);
    if (!showSearchSectionClass) {
      params.set('search', 'true');
      router.push(window.location.pathname + '?' + params, '', {
        shallow: true,
        scroll: false,
      });
    } else {
      overlayHandler();
    }
  };
  const searchEvent = () => {
    clickedSearchTabEvent(true);
  };
  const closeModal = () => {
    setShowLoginPopup(false);
  };
  if (drawerOpen) {
    sideDrawerHidden.current = true;
  }

  const getItems = async () => {
    // if (getUserIsLoggedIn()) {
    const response = await getLoginCartItems();

    setCartItems(response);
    // } else {
    //     const cartItemsArr = getCartItems();
    //     setCartItems(cartItemsArr);
    // }
  };
  useEffect(() => {
    setWebUserIdReact();
    gokwikSdk.on('checkout-ready', async function (data) {
      getItems();
    });

    getItems();
    if (addedToCart) {
      setCartAnimation(true);
      setTimeout(() => {
        setCartAnimation(false);
      }, 1000);
    }
  }, [addedToCart]);

  const trackOrderHandler = () => {
    fireEvent({
      category: 'clicked_track_icon',
      screen_name: getScreenName(),
    });
    if (!getUserIsLoggedIn()) {
      localStorage.setItem('redirectRoute', window.location.pathname);
      navigateToLoginPage(false, false, true);
    } else {
      navigateToOrderlistPage();
    }
  };
  const cartClickHandler = () => {
    fireEvent({
      category: 'clicked_cart_icon',
      screen_name: getScreenName(),
      item_count: cartItems.length || 0,
    });
    navigateToCartPage();
  };

  const onStoreClick = () => {
    setCardEffect('lowOpacity');
    fireEvent({
      category: 'clicked_cta',
      screen_name: getScreenName(),
      cta: 'store',
      parent: 'store',
    });
    setTimeout(() => {
      const params = new URLSearchParams(window.location.search);
      params.set('scrollToCat', true);
      router.push(`/` + '?' + params, '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };
  const handleSuccess = () => {
    navigateToOrderlistPage();
  };
  const hemburgerClickHandler = () => {
    // if (!hideHamIcon) {
    fireEvent({
      category: 'open_sidebar',
      screen_name: getScreenName(),
    });
    setDrawerOpen(true);
    // }
    if (showSearchSectionClass) setShowSearchSectionClass(false);
  };
  // if (categoryData?.length > 1) {
  //     categoryData[1].deeplink = "/category/mylo-care-7545";
  //     categoryData[2].deeplink = "/category/mylo-baby-7546";
  // }

  // if (categoryData?.length == 3) {
  //     categoryData[3] = communityData;
  // }
  useEffect(() => {
    if (window) {
      setUrl('/' + getSearchParams());
    }
  }, [router.asPath]);

  useEffect(() => {
    const trendingData = trendingSearchDataConstant;
    setTrendingSearchData(trendingData);
    const iseDesktopUser = isDesktopUser();
    if (
      iseDesktopUser &&
      !categoryData?.[categoryData.length - 1].downloadApp
    ) {
      let downloadAppObj = {
        tabName: 'Get Mylo App',
        deeplink: '',
        downloadApp: true,
      };
      categoryData?.push(downloadAppObj);
      setHeaderData(categoryData);
    }
  }, [categoryData]);
  return (
    <>
      <SVGSourceHeader />
      <HomeHeader
        showHeader={showHeader}
        showPopup={params?.has('imageGallery')}
        location={location}
        store={store}
        nostrip={nostrip}
      >
        <div className="logo">
          <a href={homeUrl}>
            <img
              src="https://images.myloapp.in/NestJsUploads/1682404377508-myloLogo.svg"
              title="Mylo Logo"
              alt="Mylo_logo"
            />
          </a>
        </div>
        <div
          className="hamburger"
          onClick={hemburgerClickHandler}
          // hideHamIcon={hideHamIcon}
        >
          <img
            src="https://images.myloapp.in/NestJsUploads/1682585270679-hamburger.svg"
            alt="hamburgerIcon"
            title="hamburgerIcon"
          />
        </div>

        {!showNewHeader || isDesktop ? (
          <Search
            setShowSearchSectionClass={setShowSearchSectionClass}
            showSearchSectionClass={showSearchSectionClass}
            overlayHandler={overlayHandler}
            newUX={true}
            drawerOpen={drawerOpen}
            setShowInput={setShowInput}
            showInput={showInput}
            trendingSearchData={trendingSearchData}
          />
        ) : null}

        <CartandProfileSec showShopCta={showShopCta}>
          <TrackDesktopNew onClick={trackOrderHandler}>
            <img
              alt=""
              src="https://images.myloapp.in/NestJsUploads/1727419915854-Track-Order-1.svg"
            />
            <p className="iconsText">Orders</p>
          </TrackDesktopNew>
          <DesktopShow>
            {!false && (
              <LoginDesktop
                setCartItems={setCartItems}
                loginPopUp={loginPopUp}
                setLoginPopUp={setLoginPopUp}
              />
            )}
          </DesktopShow>

          {!hideMobileSearch && !orderSuccessHeader && !showShopCta && (
            <MobileSearch
              isForJoyfulPage={isForJoyfulPage}
              onClick={() => {
                searchStateHandler();
                searchEvent();
              }}
            >
              <SVGHeader id="searchblacknew" />
            </MobileSearch>
          )}

          {showShopCta && getWebUserType() == 'A' ? (
            <ShopButton className={cardEffect} onClick={onStoreClick}>
              STORE
            </ShopButton>
          ) : null}

          {showCart && (
            <CartIcon onClick={cartClickHandler}>
              <RelativeDiv className="cartFlex">
                <CartImg
                  src="https://images.myloapp.in/NestJsUploads/1727419915857-cart-1.svg"
                  alt="Cart"
                  title="Cart"
                />
                <CartImgMobile
                  src="https://images.myloapp.in/NestJsUploads/1728026609917-tabler-icon-shopping-bag-(1).svg"
                  alt="Cart"
                  title="Cart"
                />
                {cartItems.length > 0 ? (
                  <span className={cartAnimation ? 'bounce' : ''}>
                    {cartItems.length}
                  </span>
                ) : null}
                <p className="iconsText">Cart</p>
              </RelativeDiv>
            </CartIcon>
          )}

          <ProfileImgMobileOuter
            onClick={() => {
              if (getUserIsLoggedIn()) {
                hemburgerClickHandler();
              } else {
                router.push('/login');
              }
            }}
          >
            <ProfileImgMobile
              src="https://images.myloapp.in/NestJsUploads/1752041754351-Profile_icon.svg"
              alt="Profile"
              title="Profile"
            />
            {showSsoTooltipDot && (
              <div
                style={{
                  position: 'absolute',
                  top: '2px',
                  right: '5px',
                  backgroundColor: '#ef4e5e',
                  width: '5px',
                  height: '5px',
                  borderRadius: '50%',
                }}
              ></div>
            )}
          </ProfileImgMobileOuter>
        </CartandProfileSec>
        {sideDrawerHidden.current ? (
          <SideDrawer
            categoryData={
              headerData?.length == 4
                ? headerData?.slice(0, headerData?.length - 1)
                : headerData
            }
            setDrawerOpen={setDrawerOpen}
            setShowLoginPopup={setShowLoginPopup}
            hideLogin={false}
            setCartItems={setCartItems}
            drawerOpen={drawerOpen}
            // languageRedirectionLinks={languageRedirectionLinks}
          />
        ) : null}
        <LoginPopupContainer
          closeModal={closeModal}
          showLoginPopup={showLoginPopup}
          handleSuccess={handleSuccess}
          setShowLoginPopup={setShowLoginPopup}
        />
      </HomeHeader>
      <BrandContainer
        showPopup={params?.has('imageGallery')}
        nostrip={nostrip}
        store={store}
      >
        {headerData?.map((category, index) => {
          return (
            <AnchorCoverTag
              url={category?.key || '/'}
              cardEffect={'headerAnchor'}
              element={{
                deeplinkValue: category?.key,
              }}
              key={'headerCat' + index}
            >
              {category?.tabName}
              {category?.subCategories?.length || category?.downloadApp ? (
                <OnHoverStoreHeader
                  categoryData={category?.subCategories}
                  parentIndex={index}
                  isDownloadApp={category?.downloadApp}
                />
              ) : null}
            </AnchorCoverTag>
          );
        })}
      </BrandContainer>

      {/* <SwitchDiaperButtons
                productId={productId}
                showHeader={showHeader}
                isForNewCdPage={isForNewCdPage}
            /> */}

      {showNewHeader ? (
        <NewHeaderArticle
          stage={stage}
          categoryData={categoryData}
          showInput={showInput}
          setShowInput={setShowInput}
          trendingSearchData={trendingSearchData}
          setShowSearchSectionClass={setShowSearchSectionClass}
          showSearchSectionClass={showSearchSectionClass}
          overlayHandler={overlayHandler}
          drawerOpen={drawerOpen}
          babyCareProduct={babyCareProduct}
          userType={userType}
        />
      ) : null}
    </>
  );
};

export default StoreHeaderNew;
